import YRC1 from "../../../assets/CampuLifeImages/YRC1.jpeg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import YRCbanner from "../../../assets/CampuLifeImages/YRCbanner.jpg"


const YRC = () => {

 
   const data = 
    { 
      name:"yrc",
           hover:true,
      pagename: "YRC", 
      title: "YRC Activities",
      contentImg:YRCbanner,
      para:"The Youth Red Cross (YRC) is the youth wing of the Indian Red Cross Society, aimed at fostering humanitarian values among students. It is a movement that encourages young individuals to engage in social service, health awareness, and disaster response activities. It focuses on promoting health, service, and friendship, instilling values of compassion, selflessness, and responsibility. Activities include blood donation camps, first aid training, disaster management programs, and community service initiatives. Through these efforts, students develop leadership skills and a strong sense of civic duty. ", 
      paranext:"It is empowering youth to contribute to society while building a network of responsible citizens. students gain practical exposure to crisis management and humanitarian efforts, shaping them into future leaders committed to social welfare.",
      fourhover:true,
      viewmore:true,
      viewless:true
    }

   
   const hoverContent =[
     {  img: YRC1, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: YRC1, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: YRC1, para1: "Independence Day Celebration", para2: "March 14, 2024" },
     {  img: YRC1, para1: "Independence Day Celebration", para2: "March 14, 2024" }
 ]
  
  return (
    <>
    
     <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
  )
}

export default YRC